import  React, {useState} from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {
  Paper,
  Typography
} from "@mui/material";
import HighlightOff from '@mui/icons-material/HighlightOff';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
        paddingTop: 10,
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 5
    }
  })
);

interface FormBasedContainerInstructionsProps {
    task?: any;
}

export const FormBasedContainerInstructions: React.FC<FormBasedContainerInstructionsProps> = ({
    task
}) => {
    const classes = useStyles();   
  
    const [visible, setVisible] = useState(true)

    const dismiss = () => {
        setVisible(false)
    }

    var instructions = task.instructions

    if (!instructions || !visible) {
        return null
    }
    
    return (
        <Paper className={classes.container}>                
            <Typography className="recentActivityTitle" style={{}} variant="h6">Recent Activity</Typography>
            <HighlightOff onClick={dismiss} style={{float: 'right', zIndex: 99999, color: "#888", cursor: "pointer", fontSize: "1.2em"}} />
            <Typography style={{textIndent: 20}} dangerouslySetInnerHTML={{ __html: instructions}} />
        </Paper>
    )
};

export default FormBasedContainerInstructions;
